import { QuestControlProps } from './index'
import React from 'react'

interface Props extends QuestControlProps<string> {
  disabled?: boolean
  onBlur?: () => void
}

const QuestTextAreaControl = ({
  value,
  onChange,
  disabled = false,
  onBlur
}: Props) => {
  return (
    <div className={'text-field'}>
      <div className="text-field__input">
        <>
          <textarea
            readOnly={disabled}
            value={value}
            placeholder={'Ваш ответ'}
            onChange={(e) => {
              onChange?.(e.target.value)
            }}
            onBlur={(e) => {
              onChange?.(e.target.value.trim())
              onBlur?.()
            }}
          ></textarea>
        </>
      </div>
    </div>
  )
}

export { QuestTextAreaControl }
